import React, { useMemo } from 'react';
import classNames from 'classnames';
import { ReactComponent as Add } from '../../../images/icons/icon-add.svg';
import { ReactComponent as AddEvent } from '../../../images/icons/icon-add-ivent.svg';
import { ReactComponent as AddCloseCircle } from '../../../images/icons/icon-close-add-circle.svg';
import { ReactComponent as Animation } from '../../../images/icons/icon-animation.svg';
import { ReactComponent as ArrowUpFull } from '../../../images/icons/icon-arrow-up.svg';
import { ReactComponent as ArrowLeft } from '../../../images/icons/icon-arrow-left.svg';
import { ReactComponent as ArrowLeftCurved } from '../../../images/icons/icon-arrow-left-curved.svg';
import { ReactComponent as ArrowRight } from '../../../images/icons/icon-arrow-right.svg';
import { ReactComponent as ArrowUp } from '../../../images/icons/icon-keyboard-arrow-up.svg';
import { ReactComponent as ArrowDown } from '../../../images/icons/icon-keyboard-arrow-down.svg';
import { ReactComponent as Attachment } from '../../../images/icons/icon-attachment.svg';
import { ReactComponent as Check } from '../../../images/icons/icon-check.svg';
import { ReactComponent as CheckV2 } from '../../../images/icons/icon-check-v2.svg';
import { ReactComponent as Close } from '../../../images/icons/icon-close.svg';
import { ReactComponent as CloseWide } from '../../../images/icons/icon-close-wide.svg';
import { ReactComponent as Copy } from '../../../images/icons/icon-copy.svg';
import { ReactComponent as CopyFilled } from '../../../images/icons/icon-copy-filled.svg';
import { ReactComponent as CameraOn } from '../../../images/icons/icon-camera-on.svg';
import { ReactComponent as CameraOff } from '../../../images/icons/icon-camera-off.svg';
import { ReactComponent as Dissolve } from '../../../images/icons/icon-dissolve.svg';
import { ReactComponent as DownloadSpeed } from '../../../images/icons/icon-download-speed.svg';
import { ReactComponent as Edit } from '../../../images/icons/icon-edit.svg';
import { ReactComponent as Emoji } from '../../../images/icons/icon-emoji.svg';
import { ReactComponent as Folder } from '../../../images/icons/icon-folder.svg';
import { ReactComponent as Fullscreen } from '../../../images/icons/icon-fullscreen.svg';
import { ReactComponent as InfoCircle } from '../../../images/icons/icon-info-circle.svg';
import { ReactComponent as InfoOutline } from '../../../images/icons/icon-info-outline.svg';
import { ReactComponent as InternetSpeed } from '../../../images/icons/icon-internet-speed.svg';
import { ReactComponent as KeyboardArrowLeft } from '../../../images/icons/icon-keyboard-arrow-left.svg';
import { ReactComponent as KeyboardArrowRight } from '../../../images/icons/icon-keyboard-arrow-right.svg';
import { ReactComponent as List } from '../../../images/icons/icon-list.svg';
import { ReactComponent as Live } from '../../../images/icons/icon-live.svg';
import { ReactComponent as Link } from '../../../images/icons/icon-link.svg';
import { ReactComponent as Link2 } from '../../../images/icons/icon-link2.svg';
import { ReactComponent as LogOut } from '../../../images/icons/icon-log-out.svg';
import { ReactComponent as Message } from '../../../images/icons/icon-message.svg';
import { ReactComponent as MicrophoneOn } from '../../../images/icons/icon-mic-on.svg';
import { ReactComponent as MicrophoneOff } from '../../../images/icons/icon-mic-off.svg';
import { ReactComponent as MoreHorizontal } from '../../../images/icons/icon-more-horiz.svg';
import { ReactComponent as People } from '../../../images/icons/icon-people.svg';
import { ReactComponent as Photo } from '../../../images/icons/icon-photo.svg';
import { ReactComponent as Refresh } from '../../../images/icons/icon-refresh.svg';
import { ReactComponent as RefreshCircle } from '../../../images/icons/icon-refresh-circle.svg';
import { ReactComponent as Search } from '../../../images/icons/icon-search.svg';
import { ReactComponent as Send } from '../../../images/icons/icon-send.svg';
import { ReactComponent as Settings } from '../../../images/icons/icon-settings.svg';
import { ReactComponent as Sound } from '../../../images/icons/icon-sound.svg';
import { ReactComponent as ShareScreen } from '../../../images/icons/icon-share-screen.svg';
import { ReactComponent as TabChat } from '../../../images/icons/icon-chat-tab.svg';
import { ReactComponent as TabFeeds } from '../../../images/icons/icon-feeds-tab.svg';
import { ReactComponent as TabMedia } from '../../../images/icons/icon-media-tab.svg';
import { ReactComponent as TabNotes } from '../../../images/icons/icon-notes-tab.svg';
import { ReactComponent as Unlink } from '../../../images/icons/icon-don\'t-link.svg';
import { ReactComponent as ViewersEye } from '../../../images/icons/icon-view.svg';
import { ReactComponent as VirtualBackground } from '../../../images/icons/icon-virtual-bg.svg';
import { ReactComponent as BackgroundRemove } from '../../../images/icons/icon-background-remove.svg';
import { ReactComponent as BackgroundRestore } from '../../../images/icons/icon-background-restore.svg';
import { ReactComponent as Undo } from '../../../images/icons/icon-undo.svg';
import { ReactComponent as Redo } from '../../../images/icons/icon-redo.svg';
import { ReactComponent as Bold } from '../../../images/icons/icon-bold.svg';
import { ReactComponent as Italic } from '../../../images/icons/icon-italic.svg';
import { ReactComponent as Underline } from '../../../images/icons/icon-underline.svg';
import { ReactComponent as AlignLeft } from '../../../images/icons/icon-align-left.svg';
import { ReactComponent as AlignCenter } from '../../../images/icons/icon-align-center.svg';
import { ReactComponent as AlignRight } from '../../../images/icons/icon-align-right.svg';
import { ReactComponent as OL } from '../../../images/icons/icon-ol.svg';
import { ReactComponent as UL } from '../../../images/icons/icon-ul.svg';
import { ReactComponent as Trash } from '../../../images/icons/icon-trash.svg';
import { ReactComponent as Font } from '../../../images/icons/icon-font.svg';
import { ReactComponent as Share } from '../../../images/icons/icon-share.svg';
import { ReactComponent as Question } from '../../../images/icons/icon-question.svg';
import { ReactComponent as ThreeLinesTriangle } from '../../../images/icons/icon-three-lines-triangle.svg';
import { ReactComponent as TitlesOn } from '../../../images/icons/icon-titles-on.svg';
import { ReactComponent as TitlesOff } from '../../../images/icons/icon-titles-off.svg';
import { ReactComponent as Invite } from '../../../images/icons/icon-invite.svg';
import { ReactComponent as AddInvite } from '../../../images/icons/icon-add-invite.svg';
import { ReactComponent as CheckCircle } from '../../../images/icons/icon-check-circle.svg';
import { ReactComponent as RefreshTransparent } from '../../../images/icons/icon-refresh-transparent.svg';
import { ReactComponent as SettingsSliders } from '../../../images/icons/icon-settings-sliders.svg';
import { ReactComponent as Computer } from '../../../images/icons/icon-computer.svg';
import { ReactComponent as Phone } from '../../../images/icons/icon-phone.svg';
import { ReactComponent as Email } from '../../../images/icons/icon-email.svg';
import { ReactComponent as RadioOn } from '../../../images/icons/icon-radio-on.svg';
import { ReactComponent as Play } from '../../../images/icons/icon-play.svg';
import { ReactComponent as Pause } from '../../../images/icons/icon-pause.svg';
import { ReactComponent as Calendar } from '../../../images/icons/icon-calendar.svg';
import { ReactComponent as Clock } from '../../../images/icons/icon-clock.svg';
import { ReactComponent as StopLive } from '../../../images/icons/icon-stop-live.svg';
import { ReactComponent as Headphones } from '../../../images/icons/icon-headphones.svg';
import { ReactComponent as ChatNotification } from '../../../images/icons/notification-icon-chat.svg';
import { ReactComponent as EventNotification } from '../../../images/icons/notification-icon-event.svg';
import { ReactComponent as RehearsalNotification } from '../../../images/icons/notification-icon-rehearsal.svg';
import { ReactComponent as TechCheckNotification } from '../../../images/icons/notification-icon-techcheck.svg';
import { ReactComponent as TellyNotification } from '../../../images/icons/notification-icon-telly.svg';
import { ReactComponent as Bell } from '../../../images/icons/icon-bell.svg';
import { ReactComponent as SendInvite } from '../../../images/icons/icon-send-invite.svg';
import { ReactComponent as Maximize } from '../../../images/icons/icon-maximize.svg';
import { ReactComponent as Upload } from '../../../images/icons/icon-upload.svg';
import { ReactComponent as Presenters } from '../../../images/icons/icon-presenters.svg';
import { ReactComponent as PresentersUnfilled } from '../../../images/icons/icon-presenters-unfilled.svg';
import { ReactComponent as Error } from '../../../images/icons/icon-error.svg';
import { ReactComponent as Design } from '../../../images/icons/icon-design.svg';
import { ReactComponent as TemplateAdd } from '../../../images/icons/icon-template-add.svg';
import { ReactComponent as Templates } from '../../../images/icons/icon-templates.svg';
import { ReactComponent as Move } from '../../../images/icons/icon-move.svg';
import { ReactComponent as ZoomIn } from '../../../images/icons/icon-zoom-in.svg';
import { ReactComponent as ZoomOut } from '../../../images/icons/icon-zoom-out.svg';
import { ReactComponent as PersonInShot } from '../../../images/icons/icon-person-in-shot.svg';
import { ReactComponent as Connection } from '../../../images/icons/icon-connection.svg';
import { ReactComponent as Expand } from '../../../images/icons/icon-expand.svg';
import { ReactComponent as Note } from '../../../images/icons/icon-note.svg';
import { ReactComponent as Teleprompter } from '../../../images/icons/icon-teleprompter.svg';
import { ReactComponent as Forward } from '../../../images/icons/icon-forward.svg';
import { ReactComponent as Backward } from '../../../images/icons/icon-backward.svg';
import { ReactComponent as MediaConvert } from '../../../images/icons/icon-media-convert.svg';
import { ReactComponent as MediaDelete } from '../../../images/icons/icon-media-delete.svg';
import { ReactComponent as MediaDownload } from '../../../images/icons/icon-media-download.svg';
import { ReactComponent as MediaDuplicate } from '../../../images/icons/icon-media-duplicate.svg';
import { ReactComponent as MediaEdit } from '../../../images/icons/icon-media-edit.svg';
import { ReactComponent as MediaShare } from '../../../images/icons/icon-media-share.svg';
import { ReactComponent as MediaTrim } from '../../../images/icons/icon-media-trim.svg';
import { ReactComponent as ShowboardEllipses } from '../../../images/icons/icon-showboard-ellipses.svg';
import { ReactComponent as Preview } from '../../../images/icons/icon-preview.svg';
import { ReactComponent as AudioMuted } from '../../../images/icons/icon-audio-muted.svg';
import { ReactComponent as Stream } from '../../../images/icons/icon-stream.svg';
import { ReactComponent as Record } from '../../../images/icons/icon-record.svg';
import { ReactComponent as Fit } from '../../../images/icons/icon-fit.svg';
import { ReactComponent as Takes } from '../../../images/icons/icon-takes.svg';
import { ReactComponent as FastForward } from '../../../images/icons/icon-fast-forward.svg';
import { ReactComponent as SkipArrows } from '../../../images/icons/icon-skip-arrows.svg';
import { ReactComponent as PlayPadding } from '../../../images/icons/icon-play-padding.svg';
import { ReactComponent as Volume0 } from '../../../images/icons/icon-volume-0.svg';
import { ReactComponent as Volume1 } from '../../../images/icons/icon-volume-1.svg';
import { ReactComponent as Volume2 } from '../../../images/icons/icon-volume-2.svg';
import { ReactComponent as Volume3 } from '../../../images/icons/icon-volume-3.svg';
import { ReactComponent as VolumeMute } from '../../../images/icons/icon-volume-mute.svg';
import { ReactComponent as Square } from '../../../images/icons/icon-square.svg';
import { ReactComponent as Music } from '../../../images/icons/icon-music.svg';
import { ReactComponent as MusicNote } from '../../../images/icons/icon-music-note.svg';
import { ReactComponent as MusicNoteNew } from '../../../images/icons/icon-music-note-new.svg';
import { ReactComponent as Video } from '../../../images/icons/icon-video.svg';
import { ReactComponent as Recording } from '../../../images/icons/icon-recording.svg';
import { ReactComponent as Screenshare } from '../../../images/icons/icon-screenshare.svg';
import { ReactComponent as StopScreenshare } from '../../../images/icons/icon-stop-screenshare.svg';
import { ReactComponent as ShotAutoplayManual } from '../../../images/icons/shot-autoplay-manual.svg';
import { ReactComponent as ShotAutoplayAuto } from '../../../images/icons/shot-autoplay-auto.svg';
import { ReactComponent as Titles } from '../../../images/icons/icon-titles.svg';
import { ReactComponent as Filter } from '../../../images/icons/icon-filter.svg';
import { ReactComponent as CarrotDown } from '../../../images/icons/carrot-down.svg';
import { ReactComponent as CarrotUp } from '../../../images/icons/carrot-up.svg';
import { ReactComponent as DownloadIcon } from '../../../images/icons/icon-download.svg';
import { ReactComponent as MuteSound } from '../../../images/icons/mute-sound.svg';
import { ReactComponent as PlayReset } from '../../../images/icons/play-reset.svg';
import { ReactComponent as CheckProcessing } from '../../../images/icons/icon-processing-check.svg';
import { ReactComponent as StreamPlay } from '../../../images/icons/icon-stream-play.svg';
import { ReactComponent as StreamRecord } from '../../../images/icons/icon-stream-record.svg';
import { ReactComponent as StreamStop } from '../../../images/icons/icon-stream-stop.svg';
import { ReactComponent as StreamSchedule } from '../../../images/icons/icon-stream-schedule.svg';
import { ReactComponent as EyeShown } from '../../../images/icons/eye-shown.svg';
import { ReactComponent as EyeHidden } from '../../../images/icons/eye-hidden.svg';
import { ReactComponent as ClockAlt } from '../../../images/icons/icon-clock-alt.svg';
import { ReactComponent as Timer } from '../../../images/icons/icon-timer.svg';
import { ReactComponent as Lock } from '../../../images/icons/icon-lock-simple.svg';
import { ReactComponent as Drag } from '../../../images/icons/drag-icon.svg';
import { ReactComponent as Image } from '../../../images/icons/icon-image.svg';
import { ReactComponent as Sparkle } from '../../../images/icons/sparkle.svg';
import { ReactComponent as Sparkle_AI } from '../../../images/icons/sparkle-ai.svg';
import { ReactComponent as LoopTrackOn } from '../../../images/icons/icon-repeat-loop.svg';
import { ReactComponent as LoopTrackOff } from '../../../images/icons/icon-repeat-loop-remove-cancel.svg';
import { ReactComponent as Briefcase } from '../../../images/icons/briefcase.svg';
import { ReactComponent as SendFilled } from '../../../images/icons/send-filled.svg';
import { ReactComponent as EmailFilled } from '../../../images/icons/email-filled.svg';
import { ReactComponent as AddMedia } from '../../../images/icons/add-media.svg';
import { ReactComponent as MediaFile } from '../../../images/icons/media-file.svg';
import { ReactComponent as PersonBlur } from '../../../images/icons/person-blur.svg';
import { ReactComponent as Person } from '../../../images/icons/person.svg';
import { ReactComponent as PersonUnfilled } from '../../../images/icons/person-unfilled.svg';
import { ReactComponent as Media } from '../../../images/icons/media.svg';
import { ReactComponent as MediaUnfilled } from '../../../images/icons/media-unfilled.svg';
import { ReactComponent as CheckFilled } from '../../../images/icons/check-filled.svg';
import { ReactComponent as CheckUnfilled } from '../../../images/icons/check-unfilled.svg';
import { ReactComponent as Quality } from '../../../images/icons/icon-quality.svg';
import { ReactComponent as Walkups } from '../../../images/icons/stylepacks/walkups.svg';
import { ReactComponent as Segment } from '../../../images/icons/stylepacks/segment.svg';
import { ReactComponent as Countdown } from '../../../images/icons/stylepacks/countdown.svg';
import { ReactComponent as Transition } from '../../../images/icons/stylepacks/transition.svg';
import { ReactComponent as LowerThirds } from '../../../images/icons/stylepacks/lower-third.svg';
import { ReactComponent as Location } from '../../../images/icons/icon-location.svg';
import { ReactComponent as Monitor } from '../../../images/icons/icon-monitor.svg';
import { ReactComponent as AccordionUp } from '../../../images/icons/icon-accordion-up.svg';
import { ReactComponent as AccordionDown } from '../../../images/icons/icon-accordion-down.svg';
import { ReactComponent as Leave } from '../../../images/icons/icon-leave.svg';
import { ReactComponent as Private } from '../../../images/icons/icon-private.svg';
import { ReactComponent as EyeDropper } from '../../../images/icons/icon-eyedropper.svg';
import { ReactComponent as TextUnderline } from '../../../images/icons/icon-text-underline.svg';
import { ReactComponent as MonitorCanvas } from '../../../images/icons/icon-monitor-canvas.svg';
import { ReactComponent as MonitorPresenters } from '../../../images/icons/icon-monitor-presenters.svg';
import { ReactComponent as Info } from '../../../images/icons/icon-info.svg';
import { ReactComponent as FilmCamera } from '../../../images/icons/icon-film-camera.svg';
import { ReactComponent as QuestionCircle } from '../../../images/icons/icon-question-circle.svg';
import { ReactComponent as AnimationOut } from '../../../images/icons/icon-animation-out.svg';
import { ReactComponent as AnimationIn } from '../../../images/icons/icon-animation-in.svg';
import { ReactComponent as AnimationTimer } from '../../../images/icons/icon-animation-timer.svg';
import { ReactComponent as AnimationMoveOut } from '../../../images/icons/icon-animation-move-out.svg';
import { ReactComponent as AnimationDissolve } from '../../../images/icons/icon-animation-dissolve.svg';
import { ReactComponent as FilterBookends } from '../../../images/icons/stylepacks-filter/icon-bookends.svg';
import { ReactComponent as FilterCountdowns } from '../../../images/icons/stylepacks-filter/icon-countdowns.svg';
import { ReactComponent as FilterLowers } from '../../../images/icons/stylepacks-filter/icon-lowers.svg';
import { ReactComponent as FilterSegments } from '../../../images/icons/stylepacks-filter/icon-segments.svg';
import { ReactComponent as FilterStylepacks } from '../../../images/icons/stylepacks-filter/icon-stylepacks.svg';
import { ReactComponent as FilterWalkups } from '../../../images/icons/stylepacks-filter/icon-walkups.svg';
import { ReactComponent as ArrowButtonLeft } from '../../../images/icons/icon-arrow-button-left.svg';
import { ReactComponent as ArrowButtonRight } from '../../../images/icons/icon-arrow-button-right.svg';
import { ReactComponent as CustomTheme } from '../../../images/icons/icon-custom-theme.svg';
import { ReactComponent as Crown } from '../../../images/icons/icon-crown.svg';

import {ICONS} from './icons';

export * from './colors';
export * from './icons';

interface Props {
	name: string;
	size: number;
	// replaces width + height in the svg. If you use actual width/height
	// from figma the icon is too small. Take the larger of width + height and use
	// that as the size param
	color: string;
	viewBox?: string;
	className?: string;
}

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export default function Icon(props: Props) {
	const {
		name, size, color, viewBox = '0 0 20 20', className = '',
	} = props;

	return useMemo(() => {
		switch (name) {
			case ICONS.ADD:
				return <Add id="icon-add" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ADD_EVENT:
				return <AddEvent id="icon-add-event" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ADD_CLOSE_CIRCLE:
				return <AddCloseCircle id="icon-close-add-circle" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ANIMATION:
				return <Animation id="icon-animation" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ARROW_UP_FULL:
				return <ArrowUpFull id="icon-arrow-left" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ARROW_UP:
				// rotated 90 degress in sass
				return <ArrowLeft id="icon-arrow-up" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ARROW_DOWN:
				// rotated 270 degress in sass
				return <ArrowLeft id="icon-arrow-down" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ARROW_LEFT:
				return <ArrowLeft id="icon-arrow-left" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ARROW_LEFT_CURVED:
				return <ArrowLeftCurved id="icon-arrow-left-curved" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ARROW_RIGHT:
				return <ArrowRight id="icon-arrow-right" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.KEYBOARD_ARROW_UP:
				return <ArrowUp id="icon-keyboard-arrow-up" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.KEYBOARD_ARROW_DOWN:
				return <ArrowDown id="icon-keyboard-arrow-down" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ATTACHMENT:
				return <Attachment id="icon-attachment" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.CALENDAR:
				return <Calendar id="icon-calendar" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.CAMERA_ON:
				return <CameraOn id="icon-camera-on" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.CHECK:
				return <Check id="icon-check" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.CHECK_V2:
				return <CheckV2 id="icon-check-v2" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.CAMERA_OFF:
				return <CameraOff id="icon-camera-off" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.CLOSE:
				return <Close id="icon-close" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.CLOSE_WIDE:
				return <CloseWide id="icon-close-wide" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.COPY:
				return <Copy id="icon-copy" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.COPY_FILLED:
				return <CopyFilled id="icon-copy-filled" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.DISSOLVE:
				return <Dissolve id="icon-dissolve" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.DOWNLOAD_SPEED:
				return <DownloadSpeed id="icon-download-speed" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.EDIT:
				return <Edit id="icon-edit" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.EMOJI:
				return <Emoji id="icon-emoji" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.FOLDER:
				return <Folder id="icon-folder" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.FULLSCREEN:
				return <Fullscreen id="icon-fullscreen" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.INFO_CIRCLE:
				return <InfoCircle id="icon-info-circle" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.INFO_OUTLINE:
				return <InfoOutline id="icon-info-outline" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.INTERNET_SPEED:
				return <InternetSpeed id="icon-internet-speed" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.KEYBOARD_ARROW_LEFT:
				return <KeyboardArrowLeft id="icon-keyboard-arrow-left" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.KEYBOARD_ARROW_RIGHT:
				return <KeyboardArrowRight id="icon-keyboard-arrow-right" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.LIST:
				return <List id="icon-list" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.LINK:
				return <Link id="icon-link" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.LINK2:
				return <Link2 id="icon-link2" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.LIVE:
				return <Live id="icon-live" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.LOG_OUT:
				return <LogOut id="icon-log-out" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MESSAGE:
				return <Message id="icon-message" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MICROPHONE_ON:
				return <MicrophoneOn id="icon-mic-on" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MICROPHONE_OFF:
				return <MicrophoneOff id="icon-mic-off" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.PEOPLE:
				return <People id="icon-people" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.PHOTO:
				return <Photo id="icon-photo" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.REFRESH:
				return <Refresh id="icon-refresh" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.REFRESH_CIRCLE:
				return <RefreshCircle id="icon-refresh-circle" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.SEARCH:
				return <Search id="icon-search" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.SEND:
				return <Send id="icon-send" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.SETTINGS:
				return <Settings id="icon-settings" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.SOUND:
				return <Sound id="icon-sound" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.SHARE_SCREEN:
				return <ShareScreen id="icon-share-screen" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.THREE_DOTS_HORIZONTAL:
				return <MoreHorizontal id="icon-three-dots-horizontal" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.THREE_DOTS_VERTICAL:
				return <MoreHorizontal id="icon-three-dots-vertical" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.THREE_LINES_TRIANGLE:
				return <ThreeLinesTriangle id="icon-three-lines-triangle" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.UNLINK:
				return <Unlink id="icon-unlink" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.VIEWERS_EYE:
				return <ViewersEye id="icon-view" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.VIRTUAL_BACKGROUND:
				return <VirtualBackground id="icon-virtual-background" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.BACKGROUND_REMOVE:
				return <BackgroundRemove id="icon-background-remove" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.BACKGROUND_RESTORE:
				return <BackgroundRestore id="icon-background-restore" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.BOLD:
				return <Bold id="icon-virtual-background" className={classNames(color, 'icon', className)} height={size} width={size} viewBox={viewBox} />;
			case ICONS.UNDERLINE:
				return <Underline id="icon-virtual-background" className={classNames(color, 'icon', className)} height={size} width={size} viewBox={viewBox} />;
			case ICONS.ITALIC:
				return <Italic id="icon-virtual-background" className={classNames(color, 'icon', className)} height={size} width={size} viewBox={viewBox} />;
			case ICONS.ALIGN_RIGHT:
				return <AlignRight id="icon-virtual-background" className={classNames(color, 'icon', className)} height={size} width={size} viewBox={viewBox} />;
			case ICONS.ALIGN_LEFT:
				return <AlignLeft id="icon-virtual-background" className={classNames(color, 'icon', className)} height={size} width={size} viewBox={viewBox} />;
			case ICONS.ALIGN_CENTER:
				return <AlignCenter id="icon-virtual-background" className={classNames(color, 'icon', className)} height={size} width={size} viewBox={viewBox} />;
			case ICONS.UNDO:
				return <Undo id="icon-virtual-background" className={classNames(color, 'icon', className)} height={size} width={size} viewBox={viewBox} />;
			case ICONS.REDO:
				return <Redo id="icon-virtual-background" className={classNames(color, 'icon', className)} height={size} width={size} viewBox={viewBox} />;
			case ICONS.OL:
				return <OL id="icon-virtual-background" className={classNames(color, 'icon', className)} height={size} width={size} viewBox={viewBox} />;
			case ICONS.UL:
				return <UL id="icon-virtual-background" className={classNames(color, 'icon', className)} height={size} width={size} viewBox={viewBox} />;
			case ICONS.TRASH:
				return <Trash id="icon-trash" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.FONT:
				return <Font id="icon-font" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.SHARE:
				return <Share id="icon-share" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.QUESTION:
				return <Question id="icon-share" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.TITLES_ON:
				return <TitlesOn id="icon-titles" className={classNames(color, 'icon', className)} height={size} width={size} style={isSafari ? { position: 'relative', bottom: 3 } : {}} />;
			case ICONS.TITLES_OFF:
				return <TitlesOff id="icon-titles" className={classNames(color, 'icon', className)} height={size} width={size} style={isSafari ? { position: 'relative', bottom: 3 } : {}} />;
			case ICONS.INVITE:
				return <Invite id="icon-invite" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ADD_INVITE:
				return <AddInvite id="icon-invite" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.TAB_CHAT:
				return <TabChat id="icon-chat-tab" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.TAB_FEEDS:
				return <Presenters id="icon-feeds-tab" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.TAB_MEDIA:
				return <TabMedia id="icon-media-tab" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.TAB_NOTES:
				return <TabNotes id="icon-notes-tab" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.CHECK_CIRCLE:
				return <CheckCircle id="icon-check-circle" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.REFRESH_TRANSPARENT:
				return <RefreshTransparent id="icon-refresh-transparent" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.SETTINGS_SLIDERS:
				return <SettingsSliders id="icon-settings-sliders" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.COMPUTER:
				return <Computer id="icon-computer" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.PHONE:
				return <Phone id="icon-phone" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.EMAIL:
				return <Email id="icon-email" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.RADIO_ON:
				return <RadioOn id="icon-radio-on" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.PLAY:
				return <Play id="icon-play" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.PAUSE:
				return <Pause id="icon-pause" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.CLOCK:
				return <Clock id="icon-clock" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.STOP_LIVE:
				return <StopLive id="icon-stop-live" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.HEADPHONES:
				return <Headphones id="icon-headphones" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.CHAT_NOTIFICATION:
				return <ChatNotification id="notification-icon-chat" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.EVENT_NOTIFICATION:
				return <EventNotification id="notification-icon-event" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.REHEARSAL_NOTIFICATION:
				return <RehearsalNotification id="notification-icon-rehearsal" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.TECH_CHECK_NOTIFICATION:
				return <TechCheckNotification id="notification-icon-tech-check" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.TELLY_NOTIFICATION:
				return <TellyNotification id="notification-icon-telly" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.BELL:
				return <Bell id="icon-bell" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.SEND_INVITE:
				return <SendInvite id="icon-send-invite" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MAXIMIZE:
				return <Maximize id="icon-maximize" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.UPLOAD:
				return <Upload id="icon-upload" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.PRESENTERS:
				return <Presenters id="icon-presenters" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.PRESENTERS_UNFILLED:
				return <PresentersUnfilled id="icon-presenters-unfilled" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ERROR:
				return <Error id="icon-error" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.DESIGN:
				return <Design id="icon-design" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.TEMPLATE_ADD:
				return <TemplateAdd id="icon-template-add" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.TEMPLATES:
				return <Templates id="icon-templates" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MOVE:
				return <Move id="icon-move" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ZOOM_IN:
				return <ZoomIn id="icon-zoom-in" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ZOOM_OUT:
				return <ZoomOut id="icon-zoom-out" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.PERSON_IN_SHOT:
				return <PersonInShot id="icon-person-in-shot" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.CONNECTION:
				return <Connection id="icon-connection" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.EXPAND:
				return <Expand id="icon-expand" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.NOTE:
				return <Note id="icon-note" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.TELEPROMPTER:
				return <Teleprompter id="icon-teleprompter" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.FORWARD:
				return <Forward id="icon-forward" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.BACKWARD:
				return <Backward id="icon-backward" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MEDIA_CONVERT:
				return <MediaConvert id="icon-media-convert" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MEDIA_DELETE:
				return <MediaDelete id="icon-media-delete" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MEDIA_DOWNLOAD:
				return <MediaDownload id="icon-media-download" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MEDIA_DUPLICATE:
				return <MediaDuplicate id="icon-media-duplicate" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MEDIA_EDIT:
				return <MediaEdit id="icon-media-edit" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MEDIA_SHARE:
				return <MediaShare id="icon-media-share" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MEDIA_TRIM:
				return <MediaTrim id="icon-media-trim" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.SHOWBOARD_ELLIPSES:
				return <ShowboardEllipses id="icon-showboard-ellipses" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.PREVIEW:
				return <Preview id="icon-preview" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.AUDIO_MUTED:
				return <AudioMuted id="icon-audio-muted" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.STREAM:
				return <Stream id="icon-stream" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.RECORD:
				return <Record id="icon-record" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.FIT:
				return <Fit id="icon-fit" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.TAKES:
				return <Takes id="icon-takes" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.FAST_FORWARD:
				return <FastForward id="icon-fast-forward" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.SKIP_ARROWS:
				return <SkipArrows id="icon-skip-arrows" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.PLAY_PADDING:
				return <PlayPadding id="icon-play-padding" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.VOLUME_0:
				return <Volume0 id="icon-volume-0" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.VOLUME_1:
				return <Volume1 id="icon-volume-1" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.VOLUME_2:
				return <Volume2 id="icon-volume-2" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.VOLUME_3:
				return <Volume3 id="icon-volume-3" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.VOLUME_MUTE:
				return <VolumeMute id="icon-volume-mute" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.SQUARE:
				return <Square id="icon-square" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MUSIC:
				return <Music id="icon-music" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MUSIC_NOTE:
				return <MusicNote id="icon-music-note" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MUSIC_NOTE_NEW:
				return <MusicNoteNew id="icon-music-note-new" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.VIDEO:
				return <Video id="icon-video" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.RECORDING:
				return <Recording id="icon-recording" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.SCREENSHARE:
				return <Screenshare id="icon-screenshare" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.STOP_SCREENSHARE:
				return <StopScreenshare id="icon-stop-share-screen" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.SHOT_AUTOPLAY_MANUAL:
				return <ShotAutoplayManual id="icon-shot-autoplay-manual" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.SHOT_AUTOPLAY_AUTO:
				return <ShotAutoplayAuto id="icon-shot-autoplay-auto" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.TITLES:
				return <Titles id="icon-titles" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.FILTER:
				return <Filter id="icon-filter" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.CARROT_DOWN:
				return <CarrotDown id="carrot-up" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.CARROT_UP:
				return <CarrotUp id="carrot-down" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.DOWNLOAD_ICON:
				return <DownloadIcon id="download-icon" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MUTE_SOUND:
				return <MuteSound id="icon-filter" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.PLAY_RESET:
				return <PlayReset id="icon-filter" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.CHECK_PROCESSING:
				return <CheckProcessing id="icon-check-processing" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.STREAM_PLAY:
				return <StreamPlay id="icon-stream-play" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.STREAM_RECORD:
				return <StreamRecord id="icon-stream-record" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.STREAM_STOP:
				return <StreamStop id="icon-stream-stop" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.STREAM_SCHEDULE:
				return <StreamSchedule id="icon-stream-schedule" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.EYE_HIDDEN:
				return <EyeHidden id="icon-eye-hidden" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.EYE_SHOWN:
				return <EyeShown id="icon-eye-shown" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.CLOCK_ALT:
				return <ClockAlt id="icon-clock-alt" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.TIMER:
				return <Timer id="icon-timer" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.LOCK:
				return <Lock id="icon-lock" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.DRAG:
				return <Drag id="icon-drag" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.IMAGE:
				return <Image id="icon-image" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.SPARKLE:
				return <Sparkle id="icon-sparkle" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.SPARKLE_AI:
				return <Sparkle_AI id="icon-sparkle-ai" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.LOOP_TRACK_ON:
				return <LoopTrackOn id="icon-repeat-loop" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.LOOP_TRACK_OFF:
				return <LoopTrackOff id="icon-repeat-loop-remove-cancel" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.BRIEFCASE:
				return <Briefcase id="icon-briefcase" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.SEND_FILLED:
				return <SendFilled id="icon-send-filled" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.EMAIL_FILLED:
				return <EmailFilled id="icon-email-filled" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ADD_MEDIA:
				return <AddMedia id="icon-add-media" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MEDIA_FILE:
				return <MediaFile id="icon-media-file" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.PERSON_BLUR:
				return <PersonBlur id="icon-person-blur" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.PERSON:
				return <Person id="icon-person" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.PERSON_UNFILLED:
				return <PersonUnfilled id="icon-person-unfilled" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MEDIA:
				return <Media id="icon-media" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MEDIA_UNFILLED:
				return <MediaUnfilled id="icon-media-unfilled" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.CHECK_FILLED:
				return <CheckFilled id="icon-check-filled" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.CHECK_UNFILLED:
				return <CheckUnfilled id="icon-check-unfilled" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.QUALITY:
				return <Quality id="icon-quality" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.WALKUPS:
				return <Walkups id="icon-walkups" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.SEGMENT:
				return <Segment id="icon-segment" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.COUNTDOWN:
				return <Countdown id="icon-countdown" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.TRANSITION:
				return <Transition id="icon-outro" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.LOWER_THIRDS:
				return <LowerThirds id="icon-lower-thirds" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.LOCATION:
				return <Location id="icon-location" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MONITOR:
				return <Monitor id="icon-monitor" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ACCORDION_UP:
				return <AccordionUp id="icon-accordion-up" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ACCORDION_DOWN:
				return <AccordionDown id="icon-accordion-down" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.LEAVE:
				return <Leave id="icon-leave" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.PRIVATE:
				return <Private id="icon-private" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.EYEDROPPER:
				return <EyeDropper id="icon-eyedropper" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.TEXT_UNDERLINE:
				return <TextUnderline id="icon-text-underline" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MONITOR_CANVAS:
				return <MonitorCanvas id="icon-monitor-canvas" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.MONITOR_PRESENTER:
				return <MonitorPresenters id="icon-monitor-presenter" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.INFO:
				return <Info id="icon-info" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.FILM_CAMERA:
				return <FilmCamera id="icon-film-camera" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.QUESTION_CIRCLE:
				return <QuestionCircle id="icon-question-circle" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ANIMATION_OUT:
				return <AnimationOut id="icon-animation-out" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ANIMATION_IN:
				return <AnimationIn id="icon-animation-in" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ANIMATION_TIMER:
				return <AnimationTimer id="icon-animation-timer" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ANIMATION_MOVE_OUT:
				return <AnimationMoveOut id="icon-animation-move-out" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ANIMATION_DISSOLVE:
				return <AnimationDissolve id="icon-animation-dissolve" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.FILTER_BOOKENDS:
				return <FilterBookends id="icon-filter-bookends" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.FILTER_COUNTDOWNS:
				return <FilterCountdowns id="icon-filter-countdowns" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.FILTER_LOWERS:
				return <FilterLowers id="icon-filter-lowers" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.FILTER_SEGMENTS:
				return <FilterSegments id="icon-filter-segments" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.FILTER_STYLEPACKS:
				return <FilterStylepacks id="icon-filter-stylepacks" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.FILTER_WALKUPS:
				return <FilterWalkups id="icon-filter-walkups" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ARROW_BUTTON_LEFT:
				return <ArrowButtonLeft id="icon-arrow-button-left" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.ARROW_BUTTON_RIGHT:
				return <ArrowButtonRight id="icon-arrow-button-right" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.CUSTOM_THEME:
				return <CustomTheme id="icon-custom-theme" className={classNames(color, 'icon', className)} height={size} width={size} />;
			case ICONS.CROWN:
				return <Crown id="icon-custom-theme" className={classNames(color, 'icon', className)} height={size} width={size} />;
			default:
				return <></>;
		}
	}, [name, size, color, className]);
}
